var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContractDonePageIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 40,
  viewBox: "0 0 48 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48 8.45996L16.8604 39.5996L0 22.7402L8.45996 14.2803L16.8604 22.6797L39.54 0L48 8.45996ZM16.8604 28.3398L8.45996 19.9404L5.66016 22.7402L16.8604 33.9404L42.3398 8.45996L39.54 5.66016L16.8604 28.3398Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgContractDonePageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contract-done-page-icon.4201cf2df4e5914d83fc24e8ef32f664.svg";